import { $fetch } from 'ohmyfetch'
import type {
  BasicNftGobblerErc721Metadata,
  UnmintedGobblerErc721Metadata,
  UnrevealedGobblerErc721Metadata,
} from 'pages/api/gobblers/[gobblerId]'

export {
  BasicNftGobblerErc721Metadata,
  UnmintedGobblerErc721Metadata,
  UnrevealedGobblerErc721Metadata,
}
export type AvailableGobblerReturnTypes =
  | UnrevealedGobblerErc721Metadata
  | UnmintedGobblerErc721Metadata
  | BasicNftGobblerErc721Metadata

const getPageMetadata = async (pageId: number) => {
  const drawingResponse = await $fetch<{}>(`/api/nfts/pages/${pageId}`, {
    method: 'GET',
  })
  return drawingResponse
}

const getGobblerMetadata = async (gobblerId: number) => {
  const drawingResponse = await $fetch<AvailableGobblerReturnTypes>(`/api/gobblers/${gobblerId}`, {
    method: 'GET',
  })
  return drawingResponse
}

const backendApi = {
  getPageMetadata,
  getGobblerMetadata,
}

export { backendApi }
